const carouselItems = [
  {
    title: '直播翻车年度盘点：2026上半年最离谱名场面',
    desc: '从醉酒失态到意外穿帮，盘点那些让网友笑到捶桌的瞬间',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20livestreaming%20fail%20moment%20on%20a%20smartphone%20screen%20in%20dark%20room%2C%20pink%20and%20amber%20neon%20light%20reflections%2C%20shocked%20reaction%20aesthetic%2C%20internet%20culture%20drama%2C%20editorial%20photography%20style%2C%20moody%20atmosphere%2C%20high%20contrast&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '酒店猛料深度追踪：那些走廊监控背后的故事',
    desc: '深夜酒店从来都不缺故事，我们整理了最具爆炸性的几段',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20corridor%20at%20night%20with%20dramatic%20lighting%2C%20long%20perspective%20shot%2C%20security%20camera%20aesthetic%2C%20pink%20and%20warm%20tone%20atmosphere%2C%20mysterious%20mood%2C%20cinematic%20noir%20style%2C%20editorial%20photography%2C%20suspenseful&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '反差视频揭秘：那些台上台下的双重人格瞬间',
    desc: '镜头前岁月静好，镜头后暴怒失控，最全反差合集',
    img: 'https://readdy.ai/api/search-image?query=Split%20screen%20contrast%20between%20elegant%20stage%20show%20and%20chaotic%20backstage%20reality%2C%20dramatic%20duality%20concept%2C%20pink%20and%20dark%20color%20contrast%2C%20celebrity%20double%20life%20aesthetic%2C%20editorial%20photography%2C%20artistic%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '素人网红崛起与陨落：3个月从爆火到翻车全记录',
    desc: '为什么越来越多的素人网红撑不过三个月？深度分析',
    img: 'https://readdy.ai/api/search-image?query=Rise%20and%20fall%20metaphor%20with%20phone%20screen%20showing%20social%20media%20fame%20then%20crashing%2C%20dramatic%20lighting%20transition%20from%20bright%20to%20dark%2C%20pink%20and%20amber%20accents%2C%20editorial%20photography%2C%20internet%20culture%20commentary%20aesthetic&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10 text-center">
          本周焦点大瓜
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {carouselItems.map((item, idx) => (
            <div key={idx} className="bg-white rounded-2xl overflow-hidden cursor-pointer group hover:shadow-lg transition-shadow duration-300">
              <div className="aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}